import { Component, OnInit, AfterViewInit  } from '@angular/core';
import { CrudService } from '../crud.service';
declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit, AfterViewInit  {

  constructor(private crudService: CrudService) { }
    baseUrl = this.crudService.baseUrl;
    date: number = new Date().getFullYear();
    isShow: boolean | undefined;
    topPosToStartShowing = 100;
    checkScroll() {
      
      // window의 scroll top
      // Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.
  
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  
      // console.log('[scroll]', scrollPosition);
      
      if (scrollPosition >= this.topPosToStartShowing) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
  
    // TODO: Cross browsing
    gotoTop() {
      window.scroll({ 
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    }
    ngOnInit(): void {
      var modal: HTMLElement = document.getElementById("enq-modal") as HTMLElement;
      var btn: HTMLElement = document.getElementById("myBtn") as HTMLElement;
      var span = document.getElementsByClassName("close")[0];
      btn.onclick = function () {
        modal.style.display = "block";
      }
      var s = document.createElement("script");
      s.type = "text/javascript"; s.async = true; s.src = "https://widgets.nopaperforms.com/emwgts.js";
      document.body.appendChild(s);
   
    }
    ngAfterViewInit(){


      // scroll to top
      // var btn = $('#button');

      // $(window).scroll(function() {
      //   if ($(window).scrollTop() > 100) {
      //     btn.addClass('show');
      //   } else {
      //     btn.removeClass('show');
      //   }
      // });

      // btn.on('click', function(e: any) {
      //   e.preventDefault();
      //   $('html, body').animate({scrollTop:0}, '100');
      // });

      //chat box
      var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.nopaperforms.com/emwgts.js"; document.body.appendChild(s);
      var s=document.createElement("script");    s.type="text/javascript";    s.async=true;    s.src="https://chatbot.in1.nopaperforms.com/en-gb/backend/bots/niaachtbtscpt.js/4885f35478c51848/9d4303fa6f5d402cb4dcd0e0b7c88f29";    document.body.appendChild(s);

    
    }
  }

